import React, {Component} from 'react';
import {connect} from 'react-redux';
import ContentRouter from  '../../routers/contentRouter'

class ContentHOC extends Component {

  shouldComponentUpdate(nextProps) {
    return this.props.drawerOpen === nextProps.drawerOpen
  }

  render(){
    return (
      <ContentRouter/>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    drawerOpen: state.general.get('drawerOpen')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentHOC);



// WEBPACK FOOTER //
// ./src/components/layout/content/contentHOC.js